import FormBuilder from '@components/Form';
import Page from '@components/PageAuth';
import PageTitle from '@components/PageTitle';
import NotificationComponent from '@helpers/_showNotifications';
import UserService from '@services/UserService';
import I18n from '@src/i18n';
import styled from '@src/styled-components';
import React from 'react';

import { RecoverForm } from '../forms/Recover';

type PropType = { history: { replace: Function }; match: any; }

class Recover extends React.Component<PropType> {
  private _userSvc = new UserService();

  render() {
    const Back = () => {
      return (
        this.props.history.replace('/login')
      )
    }

    const RecoverPassword = async (credentials: { username: string; }, actions: any) => {
      let response: any;
      this.setState({ isLoading: true });
      try {
        response = await this._userSvc.recoverPassword(credentials.username.trim().toLowerCase());
        if (response) {
          console.log(response)
          actions.setSubmitting(false);
          this.setState({ isLoading: false });
          NotificationComponent.Notify('success', I18n.l('titles.recover'), 'Foi enviado um novo código para o e-mail fornecido. Verifique sua caixa de entrada.');
          return (
            this.props.history.replace(`/code/${credentials.username.trim()}`)
          )
        } else {
          this.setState({ isLoading: false });
        }

      } catch (e) {
        this.setState({ isLoading: false });
        actions.setSubmitting(false);
        NotificationComponent.Notify('error', I18n.l('titles.recover'), e);
      }
    }
    return (
      <Page>
        <Content>
          <PageTitle page="recover" />
          <Description>
            <p>
              {I18n.l('recover.description')}
            </p>
          </Description>
          <FormBuilder settings={RecoverForm} onSubmit={RecoverPassword} onCancel={Back} />
        </Content>
      </Page>
    );
  }
}

const Content = styled.div`
    flex: 1;
    display: flex;
    flex-flow: column;
    justify-content: flex-start;
    align-items: flex-start;
    margin-top: 50px;`;

const Description = styled.div`
    font-size: 13px;
    line-height: 19px;
    color: #000;
`;

export default Recover;
